import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import { Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import Drawer from "@mui/material/Drawer";

const MyBankAccount = () => {
  const [open, setOpen] = React.useState(false);
  const navigate = useNavigate();
  return (
    <>
      <div className="bg-gray-100">
        <div className="flex gap-5 py-5 px-4 bg-white">
          <ArrowBackIcon onClick={() => navigate("/profile")} />
          <p className="text-xl ">View Bank Account Details</p>
        </div>
        <div className="px-3 pt-4 ">
          <div className="border-t-8 border-blue-900 rounded-2xl"></div>
          <div className="bg-white  rounded-lg">
            <p className="px-3 py-2">
              <p className="py-2">Welcome</p>
              <p className="font-bold ">
                Lets get started with adding your bank account.
              </p>
              <p className="py-2">
                This account will be used for all kinds of payments, i.e.
                commissions and bonus.
              </p>
            </p>
            <div className="py-2 px-3" onClick={() => setOpen(true)} onClose>
              <Button className="!w-full" variant="contained">
                Add Account
              </Button>
            </div>
            <React.Fragment>
              <Drawer
                anchor="bottom"
                open={open}
                onClose={() => setOpen(false)}
              >
                <div className="py-5 px-5">
                  <p className="font-bold"> Billing Details</p>

                  <div className="pt-4 px-3  ">
                    <input
                      type="text"
                      placeholder="Name"
                      className="!ml-3 !my-3 "
                    ></input>
                    <input
                      type="text"
                      placeholder="Address"
                      className=" !ml-3 !my-3 "
                    ></input>
                    <input
                      type="text"
                      placeholder="Country"
                      className="!ml-3 !my-3  "
                    ></input>
                    <Button className="!ml-12 !mt-5" variant="contained">
                      Save
                    </Button>
                  </div>
                </div>
              </Drawer>
            </React.Fragment>
            <p className="px-3">
              <p className="font-bold py-3">One user -One Account</p>
              <p className="pb-2 ">
                Please Note: Misuse can lead to action such as account
                terminiton and with holding of payments as per Shopsy's.
                <span className="text-blue-600 ">Terms and conditions</span>
              </p>
            </p>
          </div>
        </div>
        <div className="pt-4 px-3  ">
          <div className="bg-white py-5 rounded-md shadow-md pb-20 ">
            <p className="px-3 ">Bank Name</p>
            <input
              type="text"
              placeholder=""
              className="!bg-gray-200 !ml-3 !my-3 !text-xs"
            ></input>
            <p className="px-3 ">Account Number</p>
            <input
              type="text"
              placeholder=""
              className="!bg-gray-200 !ml-3 !my-3 !text-xs"
            ></input>
            <p className="px-3 ">Account holder Name</p>
            <input
              type="text"
              placeholder=""
              className="!bg-gray-200 !ml-3 !my-3 !text-xs "
            ></input>
          </div>
        </div>
      </div>
    </>
  );
};
export default MyBankAccount;
